//#region Helpers

const tooltipOtions = {
    delay: {
        show: 500,
        hide: 50
    },
    trigger: 'hover',
    boundary: 'window',
    selector: '[data-toggle="tooltip"], [data-toggle-second="tooltip"]',
    sanitize: true, //remove inline css,
    container: false,
    html: false
}

$(function () {
    $(tooltipOtions.selector).tooltip({
        delay: {
            show: tooltipOtions.delay.show,
            hide: tooltipOtions.delay.hide
        },
        boundary: tooltipOtions.boundary,
        trigger: tooltipOtions.trigger,
    })
    pickers.init()
    $.datetimepicker.setLocale(__language)
    $.datepicker.regional['pl'] = calendarTranslations
    $.datepicker.setDefaults($.datepicker.regional[__language]);
})

//$(document).on('click', () => $('.tooltip.show').tooltip('hide'))

const pickers = {
    init: function (container) {
        let $c = null

        if (container != undefined && (container.hasClass('datepicker') || container.hasClass('timepicker') || container.hasClass('datetimepicker') || container.hasClass('kdr-color-picker') || container.hasClass("monthpicker"))) {
            $c = convert.toJqueryObject(container).parent()
        }
        else if (container != undefined && container.length != 0) {
            $c = convert.toJqueryObject(container)
        } else {
            $c = $('body')
        }

        $c.find('.datepicker, .timepicker, .datetimepicker, .kdr-color-picker, .monthpicker').each(function () {
            pickers.initSingle.basedOnClass($(this))
        })
    },
    isInited($item) {
        return $item.data('isPickerInitiated') === true
    },
    initSingle: {
        basedOnClass($item) {
            if ($item.hasClass('datepicker')) this.datePicker($item);
            else if ($item.hasClass('timepicker')) this.timePicker($item)
            else if ($item.hasClass('datetimepicker')) this.datetimePicker($item)
            else if ($item.hasClass('kdr-color-picker')) this.colorPicker($item)
            else if ($item.hasClass('monthpicker')) this.monthPicker($item)
        },
        datePicker($item) {
            if (!$item.isAny() || pickers.isInited($item)) { //not init more then one time
                return
            } else if ($item.length > 1) {
                console.info("Hey, this function is for single item, not collection. I will fix it...!")
                for (var i = 0; i < $item.length; i++) {
                    picker.init($item.eq(i))
                }
                return
            }

            let props = pickers.getDefaultProps($item)
            $item.data('oldValue', $item.val())

            function setMinMaxDate($ct, $i) {
                if ($i.hasClass('datepicker-from')) {
                    let $dtp = $i.closest('.datepicker-from-to').find('.datepicker-to')
                    $dtp.datetimepicker('setOptions', { minDate: $ct })
                    $dtp.blur()
                }
                else if ($i.hasClass('datepicker-to')) {
                    let $dtf = $i.closest('.datepicker-from-to').find('.datepicker-from')

                    $dtf.datetimepicker('setOptions', { maxDate: $ct })
                    $dtf.blur()
                }

            }

            $item.datetimepicker({
                timepicker: false,
                format: props.dateFormat,
                formatDate: props.dateFormat,
                weeks: true,
                mask: true,
                validateOnBlur: true,
                fixed: false,
                lazyInit: props.IsLazyLoading,
                parentID: props.Parent,
                className: props.Classes,
                isPermanentAtInit: props.IsPermanent,
                permanentButton: props.IsAllowPermanent,
                permanentButtonTarget: $item,
                permanentButtonText: props.PermanentButtonText,
                dayOfWeekStart: __dayOfWeekStart,

                isFromBeginningButton: props.IsAllowFromBeginning,
                isFromBeginningAtInit: props.IsFromBeginning,
                fromBeginningButtonTarget: $item,
                fromBeginningButtonText: props.BeginningButtonText,

                minDate: props.minDate,
                maxDate: props.maxDate,
                onChangeDateTime: function ($ct, $i) {

                    $i.trigger({
                        type: 'kdr',
                        namespace: 'checkedValueCorrectness',
                        hasInvalidValue: undefined,
                        newValue: $ct
                    })
                },
                onSelectDate: function ($ct, $i) {
                    setMinMaxDate($ct, $i)

                    $i.trigger({
                        type: 'kdr',
                        namespace: 'checkedValueCorrectness',
                        hasInvalidValue: undefined,
                        newValue: $ct
                    })
                },
                onSelectPermanentDate: function ($ct, $i) {
                    setMinMaxDate($ct, $i)

                    $i.trigger({
                        type: 'kdr',
                        namespace: 'checkedValueCorrectness',
                        hasInvalidValue: undefined,
                        newValue: $ct
                    })
                },
                onAfterInit: function () {
                    if (props.IsPermanent || props.IsFromBeginning) {
                        $item.val(null)
                    }
                },
            })
            $item.data('isPickerInitiated', true)
        },
        timePicker($item) {

            if (!$item.isAny() || pickers.isInited($item)) { //not init more then one time
                return
            } else if ($item.length > 1) {
                console.info("Hey, this function is for single item, not collection. I will fix it...!")
                for (var i = 0; i < $item.length; i++) {
                    picker.init($item.eq(i))
                }
                return
            }


            let props = pickers.getDefaultProps($item)
            $item.data('oldValue', $item.val())

            $item.datetimepicker({
                datepicker: false,
                format: props.timeFormat,
                formatTime: props.timeFormat,
                mask: true,
                fixed: false,
                validateOnBlur: true,
                lazyInit: props.IsLazyLoading,
                parentID: props.Parent,
                className: props.Classes,
                onAfterInit: function () {
                    if (props.IsPermanent) {
                        $item.val(null)
                    }
                }
            })

            $item.data('isPickerInitiated', true)
        },
        datetimePicker($item) {

            if (!$item.isAny() || pickers.isInited($item)) { //not init more then one time
                return
            } else if ($item.length > 1) {
                console.info("Hey, this function is for single item, not collection. I will fix it...!")
                for (var i = 0; i < $item.length; i++) {
                    picker.init($item.eq(i))
                }
                return
            }

            let props = pickers.getDefaultProps($item)
            $item.data('oldValue', $item.val())

            $item.datetimepicker({
                format: props.dateFormat + ' ' + props.timeFormat,
                formatDate: props.dateFormat,
                formatTime: props.timeFormat,
                weeks: true,
                mask: true,
                validateOnBlur: true,
                lazyInit: props.IsLazyLoading,
                parentID: props.Parent,
                className: props.Classes,

                fixed: false,

                isPermanentAtInit: props.IsPermanent,
                permanentButton: props.IsAllowPermanent,
                permanentButtonTarget: $item,
                permanentButtonText: props.PermanentButtonText,

                isFromBeginningButton: props.IsAllowFromBeginning,
                isFromBeginningAtInit: props.IsFromBeginning,
                fromBeginningButtonTarget: $item,
                fromBeginningButtonText: props.BeginningButtonText,

                onAfterInit: function () {
                    if (props.IsPermanent) {
                        $item.val(null)
                    }
                },
                onClose: function () {
                    $item.trigger('xdSoft.closed');
                }
            })

            $item.data('isPickerInitiated', true)
        },
        colorPicker($item) {
            pickers.color.init($item)
        },
        monthPicker($item) {
            if (!$item.isAny() || pickers.isInited($item)) { //not init more then one time
                return
            } else if ($item.length > 1) {
                console.info("Hey, this function is for single item, not collection. I will fix it...!")
                for (var i = 0; i < $item.length; i++) {
                    picker.init($item.eq(i))
                }
                return
            }

            let props = pickers.getDefaultProps($item)
            $item.data('oldValue', $item.val())

            function setMinMaxDate($ct, $i) {
                if ($i.hasClass('datepicker-from')) {
                    let $dtp = $i.closest('.datepicker-from-to').find('.datepicker-to')
                    $dtp.datetimepicker('setOptions', { minDate: $ct })
                    $dtp.blur()
                }
                else if ($i.hasClass('datepicker-to')) {
                    let $dtf = $i.closest('.datepicker-from-to').find('.datepicker-from')

                    $dtf.datetimepicker('setOptions', { maxDate: $ct })
                    $dtf.blur()
                }

            }

            $item.datepicker(
                {
                    dateFormat: "yy-mm",
                    changeMonth: true,
                    changeYear: true,
                    showButtonPanel: true,
                    onClose: function (dateText, inst) {


                        function isDonePressed() {
                            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
                        }

                        if (isDonePressed()) {
                            var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
                            var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
                            $(this).datepicker('setDate', new Date(year, month, 1)).trigger('change');

                            $item.focusout()
                        }
                    },
                    beforeShow: function (input, inst) {

                        inst.dpDiv.addClass('month_year_datepicker')

                        if ((datestr = $(this).val()).length > 0) {
                            year = datestr.substring(0, 4);
                            month = datestr.substring(datestr.length - 2, datestr.length);
                            $(this).datepicker('option', 'defaultDate', new Date(year, month - 1, 1));
                            $(this).datepicker('setDate', new Date(year, month - 1, 1));
                            $(".ui-datepicker-calendar").hide();
                        }
                    }
                })
            $item.data('isPickerInitiated', true)
        },
    },
    show: function (pickerInput) {
        $(pickerInput).focus()
    },
    /**
     * Returns default properties for datetimepicker init
     * @param {any} input 
     */
    getDefaultProps: function (input) {
        let $i = $(input)


        let isAPer = $i.hasClass('allow-date-permanent')
        let isPer = $i.hasClass('is-permanent')

        let isABeg = $i.hasClass('allow-date-beginning')
        let isBeg = $i.hasClass('is-from-beginning')

        let isPermanentDate = $i.closest('.datepicker-from-to').length > 0

        let minDate = textHelper.isNullOrEmpty($i.data('min-date')) ? false : $i.data('min-date')
        let maxDate = textHelper.isNullOrEmpty($i.data('max-date')) ? false : $i.data('max-date')

        function notOverflowHiddenParent($item) {
            let $x;
            let $p = $item.parent()
            if ($p.css('overflow') != 'hidden') {
                $x = notOverflowHiddenParent($p)
            } else {
                $x = $p
            }
            return $x;
        }

        let $parent;
        if ($i.closest('.kdr-grid').length != 0) {
            $parent = $i.closest('.kdr-grid')
        } else if ($i.closest('.modal-content').length != 0) {
            $parent = $i.closest('.modal-content')
        } else {
            $parent = $('body')
        }
        return {
            Parent: $parent,//notOverflowHiddenParent($i),//
            IsAllowPermanent: isAPer,
            IsPermanent: isPer,
            IsAllowFromBeginning: isABeg,
            IsFromBeginning: isBeg,
            IsLazyLoading: !((isAPer && isPer) || (isBeg && isABeg) || isPermanentDate),
            PermanentButtonText: $i.data('permanentButtonText'),
            BeginningButtonText: $i.data('beginningButtonText'),
            Classes: 'dtp',
            dateFormat: __dateFormat,
            timeFormat: $i.hasClass('time-hm') ? __timeHMFormat : __timeFormat,
            minDate: minDate,
            maxDate: maxDate
        }
    },
    color: {
        getValueInput($elementInsidePicker) {
            let $valueInput
            let isPickerBox = $elementInsidePicker.hasClass('kdr-color-picker-box')
            let isInPickerBox = $elementInsidePicker.closest('.kdr-color-picker-box').length > 0

            if (isPickerBox || isInPickerBox) {
                if (isInPickerBox) {
                    $elementInsidePicker = $elementInsidePicker.closest('.kdr-color-picker-box')
                }

                let controlId = $elementInsidePicker.data('for')
                $valueInput = $('.kdr-color-picker[data-id="' + controlId + '"]').find('.kdr-color-picker-value')
            } else {
                $valueInput = $elementInsidePicker.closest('.kdr-color-picker').find('.kdr-color-picker-value')
            }

            return $valueInput
        },
        setColor($valueInput, hexColor) {
            $valueInput.css({
                'background-color': hexColor,
                'color': hexColor
            }).val(hexColor)
        },
        getSelectBox($elementInsidePicker) {
            let $box
            let isPickerBox = $elementInsidePicker.hasClass('kdr-color-picker-box')
            let isInPickerBox = $elementInsidePicker.closest('.kdr-color-picker-box').length > 0
            let isInPicker = $elementInsidePicker.closest('.kdr-color-picker')

            if (isPickerBox) {
                $box = $elementInsidePicker
            }
            else if (isInPickerBox) {
                $box = $elementInsidePicker.closest('.kdr-color-picker-box')
            }
            else {
                let controlId = pickers.color.getControl($elementInsidePicker).data('id')
                $box = $('.kdr-color-picker-box[data-for="' + controlId + '"]')
            }

            return $box
        },
        getControl($elementInsidePicker) {
            return $elementInsidePicker.closest('.kdr-color-picker')
        },
        init($control) {
            if (!$control.isAny() || $control.attr('disabled') == 'disabled' || $control.data('inited-p') === true) {
                return
            }

            let newId = uid.getNew()
            let $box = $control.find('.kdr-color-picker-box')
            $control.attr('data-id', newId)

            let $modal = $control.closest('.modal')
            if ($modal.length > 0) {
                let modalZIndex = $modal.css('z-index')
                let targetZIndex = modalZIndex + 10
                $box.css({ 'z-index': targetZIndex })

                let $grid = $box.closest('.kdr-grid')

                if (!$grid.hasClass('kdr-grid-modal')) {
                    $grid.append($box)
                }


                let popper = new Popper($control, $box, {
                    placement: 'bottom-start',
                    modifiers: {
                        preventOverflow: { enabled: false },
                    },
                });

                $box.data('popper', popper)
            }
            $box.attr('data-for', newId)
            $control.data('inited-p', true)
        },
        toggleBoxVisibility($toggler) {
            if (pickers.color.getControl($toggler).attr('disabled') == 'disabled') {
                return
            }
            let $selectBox = pickers.color.getSelectBox($toggler)

            if ($selectBox.isAny()) {

                if ($selectBox.is(':visible')) {
                    $selectBox.slideUp(125)
                } else {
                    $selectBox.data().popper.update()
                    $selectBox.slideDown(125)

                    $(document).one('mousedown', function () {
                        pickers.color.toggleBoxVisibility($selectBox)
                    })
                }

            }
        },
        getHEXColorFromCell($cell) {
            let rgbColor = $cell.css('background-color')
            return convert.bgRgbToHex(rgbColor)
        },
    }

}

$(document).on('click', '.show-picker', function () {
    let $picker = $(this).closest('.input-group').find('[class~="datepicker"], [class~="timepicker"], [class~="datetimepicker"], [class~="monthpicker"]')
    pickers.show($picker)
})
$(document).on('mouseup', '.dtp.hide-days .xdsoft_today_button', function () {
    $(this).dblclick()
})
$(document).on('click', '.kdr-color-picker-toggle', function () {
    pickers.color.toggleBoxVisibility($(this))
})
$(document).on('click mousedown', '.kdr-color-picker-cell', function () {
    let $cell = $(this)
    let $valueInput = pickers.color.getValueInput($cell)
    let hexColor = pickers.color.getHEXColorFromCell($cell)

    pickers.color.setColor($valueInput, hexColor)
})
$(document).on('paste keypress keyup blur', '.kdr-color-picker-value', function (e) {
    //validacja kiedys byc moze 
    //const regex = /^#(([a-fA-F]){0,6}|(\d{0,6}+))$/;
    const regex = /^#(([\da-fA-F]{3}){1,2}|([\da-fA-F]{4}){1,2})$/;
    let $input = $(this)
    let val = $input.val()

    if (regex.test(val)) {
        let hexColor = convert.bgRgbToHex(val)
        let $valInput = pickers.color.getValueInput($input)

        pickers.color.setColor($valInput, hexColor)
    }
})

const convert = {
    componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex
    },
    rgbToHex(r, g, b) {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b)
    },
    hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    },
    hexToRgbString(hex) {
        let r = convert.hexToRgb(hex)
        return `rgb(${r.r},${r.g},${r.b})`
    },
    bgRgbToHex(fullRgb) {
        var rgb = fullRgb.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+)/i)
        return (rgb && rgb.length === 4) ? "#" +
            ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : fullRgb;
    },
    bytesToUserReadableString(bytes) {
        if (bytes >= (1024 ** 3)) {
            return (bytes / (1024 ** 3)).toFixed(2) + " GiB";
        } else if (bytes >= (1024 ** 2)) {
            return (bytes / (1024 ** 2)).toFixed(2) + " MiB";
        } else if (bytes >= 1024) {
            return (bytes / 1024).toFixed(2) + " KiB";
        } else {
            return bytes + " B";
        }
    },
    stringToBoolean(c) {
        switch (c?.toString().toLowerCase()?.trim()) {
            case "true":
            case "yes":
            case "1":
                return true;

            case "false":
            case "no":
            case "0":
            case null:
            case undefined:
                return false;

            default:
                try {
                    return JSON.parse(c)
                } catch {
                    return c.length > 0
                }
        }
    },
    toJqueryObject(o) {
        return o instanceof $ ? o : $(o)
    },
    /**
     * Converts time to miliseconds
     * @param {any} h fe. 12:34 or 12:34:00
     * @returns time as miliseconds, fe. 45240000 (12:34)
     */
    UTCtimeToMiliseconds(h) {
        return new Date("1970-01-01T" + h).getTime()
    },
    /**
     * Converts time to ticks
     * @param {any} h fe. 12:34 or 12:34:00
     * @returns time as miliseconds, fe. 45240000000 (12:34)
     */
    UTCTimeToTicks(h) {
        return this.UTCtimeToMiliseconds(h) * 1000
    },
    /**
     * 
     * @param {any} h
     * @returns time as HH:mm:ss
     */
    timeToUTCTimeString(h) {
        if (textHelper.isNullOrEmpty(h) || !dateTimeHelper.stringIsValidTime(h)) {
            return h
        }
        else {
            let d;
            if (dateTimeHelper.stringIs12HTimeFormat(h)) {
                d = new Date("1970-01-01 " + h)
            } else {
                d = new Date("1970-01-01T" + h)
            }
            return d.toTimeString().slice(0, 8)
        }
    }
}
const checkColor = {
    luma(rgb) {
        switch ((rgb || "").replace(/\s+/g, '').toLowerCase()) {
            case "transparent":
            case "":
            case "rgba(0,0,0,0)":
                return 0;
            default: {
                let match = /\((\d+).*?(\d+).*?(\d+)\)/.exec(rgb)
                var r = parseInt(match[1], 10)
                var g = parseInt(match[2], 10)
                var b = parseInt(match[3], 10)

                var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // Rec. 709

                return luma
            }
        }
    },
    isDark(rgb) {
        return checkColor.luma(rgb) < 128
    },
    isBlack(rgb) {
        return checkColor.luma(rgb) < 40
    },
    name(hexColor) {
        //https://stackoverflow.com/questions/64137102/how-would-u-be-able-to-tell-if-a-color-is-red-or-blue-tinted-javascript
        const clrLkp = [["red", 0], ["vermilion", 15], ["brown", 20], ["orange", 30], ["safran", 45], ["yellow", 60], ["light green yellow", 75], ["green yellow", 90], ["limett", 105], ["dark green", 120], ["green", 120], ["light blue-green", 135], ["blue green", 150], ["green cyan", 165], ["cyan", 180], ["blaucyan", 195], ["green blue", 210], ["light green blue", 225], ["blue", 240], ["indigo", 255], ["violet", 270], ["blue magenta", 285], ["magenta", 300], ["red magenta", 315], ["blue red", 330], ["light blue red", 345]].reverse()

        function _rgb2hsv(r, g, b) {
            let v = Math.max(r, g, b), n = v - Math.min(r, g, b);
            let h = n && ((v == r) ? (g - b) / n : ((v == g) ? 2 + (b - r) / n : 4 + (r - g) / n));
            return [60 * (h < 0 ? h + 6 : h), v && n / v, v];
        }

        const _hex2rgb = hex => {
            const parts = hex.slice(1).match(/../g);
            if (!parts || parts.length < 3) throw new Error('Invalid hex value');
            const dec = parts.map(p => parseInt(p, 16));
            return dec;
        }

        const _hsv2name = (h, s, v) => clrLkp.find(([clr, val]) => h >= val)[0];
        const _hex2name = hex => [_hex2rgb, _rgb2hsv, _hsv2name].reduce((a, v) => v(...[a].flat()), hex);

        function _isGray(hex) {
            let h = hex.slice(1)
            let g = h.length == 3 ? h : h.match(/.{1,2}/g)
            return (g[0] == g[1] && g[1] == g[2])
        }

        return checkColor.isBlack(convert.hexToRgbString(hexColor)) ? 'black' :
            _isGray(hexColor) ? "gray" :
                _hex2name(hexColor)
    }
}
const compare = {
    /* 
     * True => Takie same
     * False => Sa rozne
    */
    arraysAreEqual(a0, a1) {
        //if (($.isArray(a0) && $.isArray(a1)) == false) {
        //    throw "compare.arraysAreEqual You need to pass two arrays!"
        //}

        if (a0.length != a1.length) {
            return false
        } else {
            let diffrentItems = $(a0).not(a1).get().length + $(a1).not(a0).get().length
            return diffrentItems == 0
        }
    }
}
const text = {
    truncate(text, length) {
        let string = text.toString().trim()
        if (string.length > length) {
            string = string.substring(0, length)
            string += '...'
        }
        return string
    }
}
const site = {
    goBack() {
        if (/#!/g.test(window.location.href)) {
            window.history.go(-2);
        } else {
            window.history.back();
        }
    }
}
const inject = {
    css: function (rules, id) {
        if (id == undefined) {
            id = null
        }

        let css = document.createElement('style')
        if (id != null) {
            //if (document.getElementById(id)) {
            //    document.getElementById(id).remove()
            //}

            let $obj = $('#' + id)
            if ($obj.length > 0) {
                $obj.remove()
            }
            css.id = id
        } else {
            css.id = uid.getNew()
        }

        css.type = 'text/css';
        if (css.styleSheet) {
            css.styleSheet.cssText = rules // Support for IE
        }
        else {
            css.appendChild(document.createTextNode(rules)); // Support for the rest
            document.getElementsByTagName("head")[0].appendChild(css)
        }; // Specifies where to place the css
    }
}

/**
 * It is managing loading indicator on specific element.
 * */
const loading = {
    keys: {
        loadingDataKey: 'loadingCounter'
    },
    /**
     * heh1
     * @param {any} selector If selector is undefined then loading will be added to body else it will be added to selected.
     * If selector !undefined then you can pass action what will be done after hide loading.
     * @param {any} callback Returns loadingId
     * @param {any} timeout Timeout is for delay show, expressed in miliseconds.
     */
    show(selector, callback, timeout = 0, progressText) {
        if (callback == undefined) {
            callback = null
        }

        if (selector == undefined || selector == null || !convert.toJqueryObject(selector).isAny()) {
            selector = $('body')
        }

        function f() {
            function manageLoadingIds($target) {

                let lc = $target.data(loading.keys.loadingDataKey)

                if (lc == undefined) {
                    lc = 1
                } else {
                    lc = parseInt(lc)
                    if (lc < 0) {
                        lc = 1
                    } else {
                        ++lc
                    }
                }

                //$target.data(loading.keys.loadingDataKey, loadingIds)
                $target.data(loading.keys.loadingDataKey, lc)
                return lc == 1;
            }

            $target = convert.toJqueryObject(selector)

            for (var i = 0; i < $target.length; i++) {
                let $t = $target.eq(i)

                if (!$t.hasClass('not-loadable') && $t.is(':visible')) {

                    if (manageLoadingIds($t)) {
                        $t
                            .attr('disabled', 'disabled')
                            .waitMe({
                                effect: 'win8',
                                bg: 'rgba(0, 0, 0, 0.25)',
                                color: '#000',
                                maxSize: '',
                                waitTime: -1,
                                text: progressText,
                                textPos: 'vertical',
                                fontSize: '',
                                source: ''
                            })
                    }
                }

            }


            //$('.tooltip.show').tooltip('hide')
            callback && callback()
        }

        if (timeout == 0) {
            f()
        } else {
            setTimeout(f, timeout)
        }
    },
    hide(selector, timeout = 0) {

        if (selector == undefined || selector == null || !convert.toJqueryObject(selector).isAny()) {
            selector = $('body')
        }

        function canCloseLoading($target) {
            let loadingCounter = $target.data(loading.keys.loadingDataKey)

            if (loadingCounter != undefined) {
                let lc = parseInt(loadingCounter)
                --lc
                $target.data(loading.keys.loadingDataKey, lc)

                return lc == 0
            } else {
                return !$target.hasClass('not-loadable')
            }
        }

        let f = () => {
            let $target = convert.toJqueryObject(selector)

            for (var i = 0; i < $target.length; i++) {
                let $t = $target.eq(i)
                if (canCloseLoading($t)) {
                    $t
                        .removeAttr('disabled')
                        .waitMe("hide")
                }
            }
        };

        if (timeout == 0) {
            f()
        } else {
            setTimeout(f, timeout)
        }
    }
}
var company = {
    set: function (index, info) {
        $.ajax({
            type: "POST",
            url: __root + "Account/SetCompany",
            traditional: true,
            data: {
                "info": info,
                "index": parseInt(index, 10)
            },
            success: function (response) {
                if (response.code == gridResponseCodes.SUCCESS) {
                    location = __root
                } else {
                    modal.getModal.danger(__l.Error, response.info, true)
                }
            },
            beforeSend: loading.show(),
            complete: loading.hide()
        })
    }
}

$(function () {
    $(document).on('click', '.company-selector', function (event) {
        let $this = $(this)

        if ($this.hasClass('company-incompatible') && event.ctrlKey !== true) {
            return 0
        }

        let id = $this.data('value')
        let info = $this.closest('.dropdown-menu').find('#CompanyInfo').data('info')
        company.set(id, info)
    })
})

let theme = {
    set: function (index, info) {
        $.ajax({
            type: "POST",
            url: __root + "Account/SetTheme",
            traditional: true,
            data: {
                "info": info,
                "index": parseInt(index, 10)
            },
            success: function (response) {
                if (response.code == gridResponseCodes.SUCCESS) {
                    location.reload(true)
                }
                else {
                    //toastr.error(response.message)
                    modal.getModal.danger(__l.Error, response.info, true)
                }
            },
            beforeSend: loading.show(),
            complete: loading.hide()
        })
    }
}

$(function () {
    $(document).on('click', '.set-theme', function () {
        let $this = $(this)
        let id = $this.data('value')
        let info = $this.closest('.dropdown-menu').find('#ThemeInfo').data('info')
        theme.set(id, info)
    })
})

$(function () {
    $(document).on('click', '.set-theme-myaccount', function () {
        let $this = $(this)
        let id = $this.data('value')
        let info = $this.closest('.user-qualification-panel-grid').find('#ThemeInfo').data('info')
        theme.set(id, info)
    })
})

////////////////
// SUBSTITUTE //
////////////////
$(function () {
    $(document).on('click', '.substitute-selector', function () {
        let $this = $(this)
        //let index = $this.data('id')
        let index = $this.data('value')
        let info = $this.closest('.dropdown-menu').find('#substitute-selector-info').data('info')

        $.ajax({
            type: "POST",
            url: __root + 'Account/Substitute',
            traditional: true,
            data: {
                info: info,
                index: index
            },
            success: function (response) {
                if (response.code == gridResponseCodes.SUCCESS) {
                    location = __root
                } else if (response.code == gridResponseCodes.ERROR) {
                    //toastr.error(response.info)
                    modal.getModal.danger(__l.Error, response.info, true)
                }
                else {
                    //toastr.warning(response.info)
                    modal.getModal.warning("~{Warning}", response.info, true)
                }
            },
            beforeSend: function () {
                $(tooltipOtions.selector).tooltip('dispose')
            }
        });
    })

    $(document).on('click', '.substitute-terminate-button', function () {
        $.ajax({
            type: "GET",
            url: __root + 'Account/TerminateSubstitute',
            processData: false,
            traditional: true,
            contentType: "application/json",
            dataType: 'json',
            success: function (response) {
                switch (response.statusCode) {
                    case 200:
                        location = __root
                        break;
                    case 400:
                        ShowErrors(response.value)
                        break
                }
            }
        });
    })

    let requesting = false;
    $(document).on('paste input', '.substitute-input', function () {
        let $this = $(this)
        if (requesting == false) {


            let $parent = $this.closest('div')
            let value = $this.val()
            $.ajax({
                type: "POST",
                url: __root + 'Account/GetUsersToSubstitute',
                dataType: 'html',
                traditional: true,
                data: {
                    pattern: value
                },
                success: function (data) {
                    $parent.siblings().remove()
                    let $partial = $(jQuery.parseHTML(data, false))

                    //$partial.find(tooltipOtions.selector).tooltip({
                    //    delay: {
                    //        show: tooltipOtions.delay.show,
                    //        hide: tooltipOtions.delay.hide
                    //    },
                    //    boundary: tooltipOtions.boundary,
                    //    trigger: tooltipOtions.trigger
                    //})
                    $parent.parent().append($partial)
                    tooltipHelper.init($parent)
                },
                beforeSend: function () {
                    requesting = true
                    $(tooltipOtions.selector).tooltip('hide')
                },
                complete: function () {
                    requesting = false
                },
            })
        }
    })

    $(document).on('change input', '.company-search-input', function () {
        let $input = $(this)
        let v = $input.valExtended().trim();

        let $items = $input.closest('.dropdown-menu').find('.company-selector')

        if (textHelper.isNullOrEmpty(v)) {
            $items.show()
        } else {
            for (let i = 0; i < $items.length; i++) {
                let $item = $items.eq(i)
                let text = $item.text().trim().toLowerCase()

                if (text.includes(v)) {
                    $item.show()
                } else {
                    $item.hide()
                }
            }
        }
    })

    $(document).on('classChangedTrigger', '.kdr-control-mddm-btn .dropdown-menu', function () {
        let $this = $(this)
        let $input = $this.find('.substitute-input')
        if ($input.length > 0) {
            $input.trigger("input")
        }
    })
})

function ShowErrors(errors) {
    $(errors).each(function (i) {
        modal.getModal.danger(__l.Error, this.errorDescription, true)
    })
}

$(document).on('mouseover', '.draggable:not(.reset-inset)', function () {
    let $this = $(this)
    let $handle = $this.find('.draggable-handle')
    let key = 'draggableResetInitedP'
    let isInited = $this.data(key)

    if (isInited) return

    $this.draggable({
        handle: $handle,
        scroll: false,
        drag: function () {
            let $this = $(this)
            let $handle = $this.find('.draggable-handle')

            $.each($handle.isInViewport(), function (propertyName, propertyValue) {
                if (propertyValue == false) {
                    $handle.mouseup()
                    if ($handle.closest('.modal').length > 0) {
                        let oldStyles = $this.attr('style').split(';').filter(f => f.length > 0).map(u => u.trim())

                        //"yAxlepx auto auto xAxlepx"
                        let styles = oldStyles.filter(u => u.includes('inset'))
                        let insets = []
                        if (styles.length > 0) {
                            insets = styles[0].split(':')[1].trim().split(' ')
                        }

                        insets[0] = '0px'
                        insets[3] = '0px'

                        let newStyles = oldStyles.filter(u => !u.includes('inset'))
                        newStyles.push('inset: ' + insets.join(' '))

                        $this.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
                            $this.attr('style', newStyles.join("; ").trim())
                                .removeClass('reset-inset')
                        })
                            .addClass('reset-inset')

                        return false
                    } else {
                        $this.css('inset', '')
                    }
                }
            })

        },
        stop: function () {
            $this.css('height', '')
        }
    })

    $handle.css('cursor', 'move')

    $this.data(key, !isInited)
})

$(function () {
    $('a.language-selector').click(function () {
        $.ajax({
            type: "GET",
            url: __root + 'Account/SetLanguage?langID=' + $(this).data('value'),
            processData: false,
            contentType: "application/json",
            dataType: 'json',
            success: function (response) {
                switch (response.statusCode) {
                    case 200:
                        location.reload()
                        break;
                    case 400:
                        ShowErrors(response.value)
                        break
                }
            }
        });
    })
})

/**
 *  Handy form for debuging with console.log.
*/
var deb = function (item) {
    console.log(item)
}

/** EXPERIMENTAL
 *  Get/Set value from inputs, extended for 
 *  datetimepicker with permanent property,
 *  dropdownlist w[/o] multiselect
 *  tristate checkboxes. */
$.fn.valExtended = function (value, fireEventsP = false, selectMDDLItemsAsyncP = true) {
    let $t = this
    let elementToReturn = null
    const datePermanent = '9999-01-01'
    let hasInvalidValue = false

    /** Set value */
    if (value != undefined) {
        if ($t.hasClass('kdr-dropdown-w-search-item_selected')) {
            let $items = []
            let $dropdownMenu = $t.data('bs.dropdown')?._menu ?? document.getElementById($t.attr('data-target'))
            if (!($dropdownMenu instanceof jQuery)) {
                $dropdownMenu = $($dropdownMenu)
            }
            if (value === '' || value == null) {
                //wylaczanie wszystkich wybraych elementow
                let values = $t.data('value')

                if (Array.isArray(values) && values.length > 0) {
                    for (var i = 0; i < values.length; i++) {
                        $items.push($dropdownMenu.find('.kdr-dropdown-w-search-item[data-value="' + $.escapeSelector(values[i]) + '"]'))
                    }
                } else {
                    $items.push($dropdownMenu.find('.kdr-dropdown-w-search-item[data-value="' + $.escapeSelector(values) + '"]'))
                }
            }
            else if (Array.isArray(value)) {
                for (var i = 0; i < value.length; i++) {
                    $items.push($dropdownMenu.find('.kdr-dropdown-w-search-item[data-value="' + $.escapeSelector(value[i]) + '"]'))
                }
            }
            else if (value instanceof jQuery && value.hasClass('kdr-dropdown-w-search-item')) {
                $items = value
            }
            else {
                $items = $dropdownMenu.find('.kdr-dropdown-w-search-item[data-value="' + $.escapeSelector(value) + '"]')
            }
            kdrDropdown.selectItems($t, $items, fireEventsP, selectMDDLItemsAsyncP, () => {
                $t.trigger({
                    type: disabler.events.disabler
                })
            })
        }
        else if ($t.attr("type") == "checkbox") { //fixme pomyslec jak uwspolnic z tristateCheckbox.changeState($cb)
            let v = convert.stringToBoolean(value)
            $t.prop('checked', v)

            if (fireEventsP) {
                $t.trigger('change')
            }
        }
        else if ($t.attr("type") == "radio") {
            let v = $t.attr("value") == value
            $t.prop('checked', v).change()
        }
        else if ($t.hasClass('datepicker') || $t.hasClass('allow-date-permanent')) {

            if ($t.hasClass('allow-date-permanent') && (value == datePermanent || value == $t.data('permanentButtonText'))) {
                $t.data('isPermanent', true)
                    .attr('placeholder', $t.data('permanentButtonText'))
                    .val('')
                value = ''
            }
            else {
                $t.data('isPermanent', false)
                    .removeClass('is-permanent')
                    .attr('placeholder', null)
                let v, m;
                const based = /(\d{4})-(\d{1,2})-(\d{1,2})/
                const pol = /(\d{1,2})\.(\d{1,2})\.(\d{4})/
                const murica = /(\d{1,2})\/(\d{1,2})\/(\d{4})/

                if ((m = based.exec(value)) !== null) {
                    v = m[0]
                }
                else if ((m = pol.exec(value)) !== null) {
                    v = `${m[3]}-${m[2]}-${m[1]}`
                }
                else if ((m = murica.exec(value)) !== null) {
                    v = `${m[3]}-${m[1]}-${m[2]}`
                } else {
                    hasInvalidValue = true
                    v = value
                }

                $t.val(v)
                value = v
            }
        }
        else if ($t.hasClass('kdr-grid-input-tinymc-wrapper')) {
            if ($t.hasClass('kdr-language')) {
                let langCode = $t.closest('[data-language]').data('language')
                setTimeout(() => { tinyMCE.get($t.prop('id')).setContent(value[langCode]) }, "1000");
            } else {
                setTimeout(() => { tinyMCE.get($t.prop('id')).setContent(value) }, "1000");
            }
        }
        else if ($t.hasClass('kdr-language')) {
            let langCode = $t.closest('[data-language]').data('language')
            $t.val(value[langCode])
        }
        else if ($t.hasClass('kdr-ddl-custom')) {
            selectableDropdown.selectValuesWPurge($t, value)
        }
        else if ($t.hasClass('kdr-color-picker-value')) {
            pickers.color.setColor($t, value)
        }
        else if ($t.hasClass('html-editor') && $t.hasClass('mce-content-body')) {
            tinymce.get($t.prop('id')).setContent(value)
        }
        else if ($t.hasClass('kdr-grid-files-input')) {
            controls.fileControl.setFiles($t, value)
            controls.fileControl.refreshUI($t)
        }
        else {
            $t.val(value)
        }


        $t.data('valueIsInvalid', hasInvalidValue)
            .trigger({
                type: 'kdr',
                namespace: 'checkedValueCorrectness',
                hasInvalidValue: hasInvalidValue,
                newValue: value
            })


        if (!$t.hasClass('kdr-dropdown-w-search-item_selected')) {
            $t.trigger({
                type: disabler.events.disabler
            })
        }

        elementToReturn = $t
    }
    /** Get value */
    else {
        if ($t.hasClass('allow-date-permanent') && $t.data('isPermanent') === true) {
            elementToReturn = datePermanent
        }
        else if ($t.hasClass('allow-date-beginning') && $t.data('isFromBeginning') === true) {
            elementToReturn = '1900-01-01'
        }
        else if ($t.hasClass('datepicker') && $t.val().includes("_")) {
            return null;
        }
        else if ($t.hasClass('kdr-dropdown-w-search-item_selected')) {
            elementToReturn = $t.data('value')
        }
        else if ($t.attr("type") == "checkbox") {
            if ($t.prop('indeterminate')) {
                elementToReturn = 'indeterminate'
            } else {
                elementToReturn = $t.prop('checked')
            }
        }
        else if ($t.hasClass('kdr-grid-files')) {
            elementToReturn = controls.fileControl.getFiles($t.find('.grid-file-input'))
        }
        else if ($t.hasClass('kdr-grid-files-input')) {
            elementToReturn = controls.fileControl.getFiles($t)
        }
        else if ($t.hasClass('kdr-ddl-custom')) {
            elementToReturn = selectableDropdown.getSelectedValues($t)
        }
        else if ($t.hasClass('kdr-frax-single-select')) {
            //elementToReturn = $t.jstree("get_selected")[0]
            elementToReturn = $t.jstree("get_selected_node").find('.jstree-clicked').data('value') ?? $t.jstree("get_selected")[0]
        }
        else if ($t.hasClass('radio-buttons-wrapper')) {
            let $radio = $t.find('.kdr-custom-radio:checked')
            elementToReturn = $radio.length == 1 ? parseInt($radio.val(), 10) : ''
        }
        else if ($t.hasClass('kdr-frax-multi-select')) {
            elementToReturn = $t.jstree("get_checked")
        }
        else if ($t.hasClass('kdr-frax-dropdown-button')) {
            let dropdownId = $t.data('target')
            let $tree = $('#' + dropdownId).find('.kdr-frax--tree')

            elementToReturn = $tree.valExtended()
        }
        else if ($t.hasClass('kdr-frax-folder')) {
            elementToReturn = fraxFolder.getSelectedNodeValue($t)
        }
        else if ($t.hasClass('html-editor') && $t.hasClass('mce-content-body')) {
            elementToReturn = tinymce.get($t.prop('id')).getContent()
        }
        else if ($t != undefined && $t.val() != null && $t.val() != undefined && $t.val() != null) {
            elementToReturn = $t.val().trim()
        }
    }

    return elementToReturn
}
$.fn.checkNumericInputValueCorrectnes = function (value) {
    let $this = this

    let regex;

    let groupSeparator = $this.data('groupSeparator')
    if (groupSeparator == ' ') {
        groupSeparator = ' '

    }
    if ($this.data('numericType') == 'decimal') {
        let decimalSeparator = $this.data('decimalSeparator')
        regex = new RegExp(`^-?\\d*[${decimalSeparator}]?\\d*$`)

    } else {
        regex = /^-?[0-9]*$/
    }

    return regex.test(value);
}
$.fn.inputFilter = function (inputFilter) {
    return this.on("input keydown keyup blur drop paste", function (e) {
        if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
            this.value = "";
        }
    });
}
$.fn.getPositionInViewport = function () {
    let $this = $(this)
    if ($this.length > 0) {

        let elementTop = $this.offset().top
        let elementBottom = elementTop + $this.outerHeight()
        let elementLeft = $this.offset().left
        let elementRight = elementLeft + $this.outerWidth()

        return {
            top: elementTop,
            bottom: elementBottom,
            left: elementLeft,
            right: elementRight
        }
    } else {
        return {
            top: undefined,
            bottom: undefined,
            left: undefined,
            right: undefined
        }
    }
}
$.fn.isInViewport = function () {
    let thisPosition = $(this).getPositionInViewport()
    let viewportPosition = getViewportPosition()

    return {
        top: thisPosition.top > viewportPosition.top,
        bottom: thisPosition.bottom < viewportPosition.bottom,
        left: thisPosition.left > viewportPosition.left,
        right: thisPosition.right < viewportPosition.right
    }
}
$.fn.isAny = function () {
    return convert.toJqueryObject(this).length != 0
}
$.fn.appendToWithIndex = function (to, index) {
    if (!to instanceof jQuery) {
        to = $(to);
    };
    if (index === 0) {
        this.prependTo(to)
    } else {
        this.insertAfter(to.children().eq(index - 1));
    }
}
$.fn.existOnDOMP = function () {
    return $(this).prop('isConnected') ?? false
}
$.fn.reverse = [].reverse

$.fn.getScrollBarWidth = function () {
    let width = $(this).prop('offsetWidth') - $(this).prop('clientWidth')
    return 1 == width ? 0 : width
}
function getViewportPosition() {
    let $window = $(window)
    let viewportTop = $window.scrollTop()
    let viewportBottom = viewportTop + $window.height();
    let viewportLeft = $window.scrollLeft()
    let viewportRight = viewportLeft + + $window.width()

    return {
        top: viewportTop,
        bottom: viewportBottom,
        left: viewportLeft,
        right: viewportRight,
    }
}
function isNullOrUndefined(element) { return (element == undefined || element == null) }
function ShowErrors(errors) {
    $(errors).each(function (i) {
        modal.getModal.danger(__l.Error, this.errorDescription, true)
    })
}
const textHelper = {
    copyTextToClipboard(text) {
        text = text.trim()


        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        } else {
            let $input = $("<input>").css('opacity', 0);
            $input.val(text);
            $('body').append($input);
            $input.focus().select();

            return new Promise((res, rej) => {
                document.execCommand('copy') ? res() : rej();
                $input.remove();
            });
        }
    },
    copyHtmlToClipboard(text) {
        const originalText = text.replace(/<[^>]*>/g, '');
        const boldText = text;
        const blobHtml = new Blob([boldText], { type: "text/html" });
        const blobText = new Blob([originalText], { type: "text/plain" });
        const data = [new ClipboardItem({
            ["text/plain"]: blobText,
            ["text/html"]: blobHtml,
        })];

        return new Promise((res, rej) => {
            navigator.clipboard.write(data) ? res() : rej();
        });

    },
    format(text, ...args) {
        if (text == undefined || text.length == 0 || args.length == 0) {
            return text
        }
        var s = text,
            i = args.length;

        while (i--) {
            s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), args[i]);
        }
        return s;
    },
    isNullOrEmpty(text) {
        let t = text;

        if (typeof (t) == 'string') {
            t = t.trim()
        }

        switch (t) {
            case "":
            case "0":
            case null:
            case false:
            case undefined:
            case typeof this === 'undefined':
                return true;
            case 0:
            default: return false;
        }
    },
    escapeCharacters(text) {
        return text?.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1') ?? undefined
    },
    countCharactersAndDisplay($input) {
        let $charCounter = $input.data('charCounter')
        let $charCounterValue = $input.data('charCounterValue')
        let maxLength = $input.data('charCounterMax')

        if (($charCounter == undefined || $charCounter.length == 0) && (!$input.hasClass('kdr-question-input') && !$input.hasClass('survey-new-order-text-input'))) {
            $charCounter = $input.closest('td').find('.char-counter')

            if ($charCounter.length == 0) {
                $charCounter = $input.closest('div').find('.char-counter')
            }

            $charCounterValue = $charCounter.find('.char-counter-current-value')

            $input.data('charCounter', $charCounter)
            $input.data('charCounterValue', $charCounterValue)

            if ($charCounter.data('max') != undefined) {
                maxLength = $charCounter.data('max')
                $input.data('charCounterMax', maxLength)
            }
        }
        else if (($charCounter == undefined || $charCounter.length == 0) && ($input.hasClass('kdr-question-input') || $input.hasClass('survey-new-order-text-input'))) {
            $charCounter = $input.closest('.count-chars-parent').find('.char-counter')
            $charCounterValue = $charCounter.find('.char-counter-current-value')

            $input.data('charCounter', $charCounter)
            $input.data('charCounterValue', $charCounterValue)

            if ($charCounter.data('max') != undefined) {
                maxLength = $charCounter.data('max')
                $input.data('charCounterMax', maxLength)
            }
        }

        let valueLength = $input.val().trim().length
        $charCounterValue.text(valueLength)

        if (maxLength != undefined && maxLength != '') {
            if (valueLength > maxLength) {
                $charCounter.addClass('text-danger')
            } else {
                $charCounter.removeClass('text-danger')
            }
        }
    },
    wrapText(text, breakAfter){
        const wrap = (s, w) => s.replace(
            new RegExp(`(?![^\\n]{1,${w}}$)([^\\n]{1,${w}})\\s`, 'g'), '$1\n'
        );
        return wrap(text, breakAfter);   
    }
}
const tooltipHelper = {
    /**
     * It's looking for any item which is selectable by selector from options (@param options.selector) and initiating tooltip on items
     * @param {any} $container container for items 
     * @param {any} options default tooltipOptions
     * @returns
     */
    init($container, options = tooltipOtions) {
        let $items = $container.find(options.selector ?? tooltipOtions.selector)

        $items.each((i, e) => {
            let $item = $items.eq(i)
            let o = options

            if ($item.data('html') != undefined) {
                o.html = $item.data('html')
            }

            tooltipHelper.initOnItem($item, o)
        })

        return $items
    },
    /**
     * Init tooltip on this items with options
     * @param {any} $item 
     * @param {any} options default tooltipOptions
     * @returns
     */
    initOnItem($item, options = tooltipOtions) {
        let opt = {
            delay: {
                show: options.delay?.show ?? tooltipOtions.delay.show,
                hide: options.delay?.hide ?? tooltipOtions.delay.hide
            },
            container: options.container ?? tooltipOtions.container,
            sanitize: options.sanitize ?? tooltipOtions.sanitize,
            boundary: options.boundary ?? tooltipOtions.boundary,
            trigger: options.trigger ?? tooltipOtions.trigger,
            html: $item.data('html') ?? options.html ?? tooltipOtions.html
        };
        if (options.template != undefined) opt['template'] = options.template
        if (options.title != undefined) opt['title'] = options.title


        $item.tooltip(opt)
        return $item
    },
    removeFromItem($item) {
        $item.tooltip('dispose')
        return $item
    }
}
const arrayHelper = {
    /**
     * Remove duplicates from array.
     * @param {any} arr Array from wher should remove duplicates.
     * @returns new array without duplicates
     */
    unique(arr) {
        var r = []
        $.each(arr, (i, e) => {
            if ($.inArray(e, r) == -1) r.push(e)
        })
        return r
    },
    /**
     * Sorting array ascending and returns new set.
     * @param {any} arr Array to sort
     * @param {any} asc DEFAULT true, if TRUE then it's sorting ascending, if FALSE then descending
     * @returns new sorted array
     */
    sortNumbers(arr, asc = true) {
        let r = arr
        return r.sort((a, b) => asc ? a - b : a + b)
    },
    /**
     *
     * @param {array} array
     * @param {any} keyOrIterator
     * @returns {array}
     */
    groupBy(array, keyOrIterator) {
        var iterator, key;

        // use the function passed in, or create one
        if (typeof keyOrIterator !== 'function') {
            key = String(keyOrIterator);
            iterator = function (item) { return item[key]; };
        } else {
            iterator = keyOrIterator;
        }

        return array.reduce(function (memo, item) {
            var key = iterator(item);
            memo[key] = memo[key] || [];
            memo[key].push(item);
            return memo;
        }, {});
    }
}
const imageHelper = {
    setImageOnInputChangedSelected(event, $input, callback) {
        let $targetDiv = $($input.data('target'))
        var selectedFile = event.target.files[0];

        if (selectedFile != undefined && selectedFile.type.includes('image') === true) {
            $targetDiv[0].title = selectedFile.name;

            var reader = new FileReader();
            reader.onload = function (event) {
                $targetDiv[0].src = event.target.result;
                loading.hide($targetDiv)

                callback && callback($targetDiv)
            };
            loading.show($targetDiv)
            reader.readAsDataURL(selectedFile);
        }
    }

}
const fileDownloadHelper = {
    download(link, beforeSend, callback, previewP) {

        var request = new XMLHttpRequest();
        request.responseType = 'blob';
        request.open('GET', link);
        request.addEventListener('load', function () {
            let response = request.response
            let isFileResponse = response.type == 'application/octet-stream'
            if (isFileResponse) {
                let fileName = request.getResponseHeader('Content-Disposition').match(`filename=(.*);`)[1].replace(`"`, '').replace(`"`, '');
                controls.parseDownloadFileResponse(response, null, request, true, previewP)
                callback(isFileResponse, response, fileName);
            } else {
                let currentCallback = (errorMessage) => {
                    modal.getModal.danger(__l.Error, errorMessage, true)
                    callback(isFileResponse);
                }

                if (response.type == 'application/json') {
                    try {
                        response.text().then((json) => {
                            let em = JSON.parse(json)?.message ?? __l.SomethingWentWrong
                            currentCallback(em)
                        })
                    }
                    catch {
                        currentCallback(__l.SomethingWentWrong)
                    }
                } else {
                    currentCallback(__l.SomethingWentWrong)
                }
            }
        });

        beforeSend && beforeSend()
        request.send();
    }
}
const nullIf = function (value, expression) {
    if (value == expression) {
        return null;
    } else {
        return value;
    }
}
const toastrTypes = ["success", "info", "warning", "error"]

$(document).on('click', '.return-site', function (e) {
    site.goBack()
})

$(document).on("click", ".change-site", function(e) {
    e.preventDefault(); 
    
    var url = $(this).attr("href"); 
    
    window.location.href = url; 
});

$(document).on('keyup', '.kdr-grid textarea, .auto-adjust-height', function (e) {
    let $this = $(this)
    let isEmpty = 0 == $this.val().length
    if (e.keyCode != 13 || ($this.closest('.kdr-grid').length > 0 && isEmpty)) {
        return false
    } else {
        $this.css({
            'height': 'auto',
            //'overflow-y': 'hidden'
        }).height($this.scrollHeight)
    }
})
$(document).on('click', '.copy-text[data-copy-from]', function () {
    let text = $($(this).data('copyFrom')).text()
    textHelper.copyTextToClipboard(text)
        .then(() => toastr.info(text, __l.CopiedTextToClipboard))
        .catch(() => toastr.error(text, __l.ErrorCannotCopy));
})
$(document).on('click', '.copy-text:not([data-copy-from])', function () {
    let text = $(this).text()
    textHelper.copyTextToClipboard(text)
        .then(() => toastr.info(text, __l.CopiedTextToClipboard))
        .catch(() => toastr.error(text, __l.ErrorCannotCopy));
})
$(document).on('click', '.blur', function () {
    $(this).blur()
})

/**https://www.ietf.org/rfc/rfc4122.txt */
let uid = {
    getNew: function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

const visualHelper = {
    sizes: {
        maximized: 'maximized',
        minimized: 'minimized',
    },
    init($vh) {
        if ($vh.data('isInitiated') === true) {
            return false
        }

        let $minimizeBtn = $vh.find('.visual-helper-minimize')
        let $showBtn = $('.visual-helper-show[for="' + $vh.attr('id') + '"]')

        $showBtn.on('click', function () {
            $showBtn.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
                $showBtn.hide()
                $showBtn.removeClass('button-right-out')

                $vh.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
                    $vh.removeClass('window-left-in')
                })
                $vh.show()
                $vh.addClass('window-left-in')
            })

            $showBtn.addClass('button-right-out')
        })
        $minimizeBtn.on('click', function () {
            $vh.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
                $vh.hide()
                $vh.removeClass('window-right-out')

                $showBtn.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
                    $showBtn.removeClass('button-left-in')
                })

                $showBtn.show()
                $showBtn.addClass('button-left-in')
            })

            $vh.addClass('window-right-out')
        })

        $vh.data('isInitiated', true)
        $vh.fadeIn()
    },
    moveToTheScreen($vh) {
        let $handle = $vh.find('.draggable-handle')
        let insetsCurrent = $vh.attr('style').split(';').filter(f => f.includes('inset'))[0] //$vh.css('inset').split(' ')
        if (insetsCurrent == undefined) {
            return false
        }

        let isInViewPort = true
        let insetsNew = insetsCurrent.trim().split(' ').filter(f => !f.includes('inset') && !f.includes('auto'))

        $.each($vh.isInViewport(), function (propertyName, propertyValue) {
            if (propertyValue == false) {
                $handle.mouseup()
                isInViewPort = false

                if (propertyName == 'right') {
                    insetsNew[1] = 'calc(98vw - ' + $vh.data(visualHelper.sizes.maximized) + ')'
                } else if (propertyName == 'bottom') {
                    insetsNew[0] = 'calc(98vh - ' + $vh.outerHeight() + 'px)'
                }
            }
        })

        if (isInViewPort == false) {
            $vh.addClass('animated-fix-inset')
            $vh.css('inset', insetsNew[0] + ' auto auto ' + insetsNew[1])

            setTimeout(function () {
                $vh.removeClass('animated-fix-inset')
            }, 125)
        }
    },
    hideTooltips($vh) {
        $vh.find(tooltipOtions.selector).tooltip('hide')
    }
}
const dateTimeHelper = {
    consts: {
        re24: /^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/,
        re12: /^(0?[1-9]|1[0-2]):[0-5]\d(:[0-5]\d)?\s?([AaPp][Mm])$/
    },
    stringIsValidTime(value) {
        return this.consts.re24.test(value) || this.stringIs12HTimeFormat(value);
    },
    stringIs12HTimeFormat(value) {
        return this.consts.re12.test(value)
    }
}

const iconHelper = {
    ToggleIconFill($icon) {

        if ($icon.data('prefix') == 'fal') {
            $icon.removeClass('fal far fab').addClass('fas');
            return true;
        } else {
            $icon.removeClass('fas far fab').addClass('fal');
            return false;
        }
    },
}

const copyCanvas = {
    copy($divElement) {
        if (!$divElement.length) {
            toastr.error('', __l.SomethingWentWrong);
            return;
        }

        const el = $divElement[0];
        const rect = el.getBoundingClientRect(); 
        const cssWidth = rect.width;
        const cssHeight = rect.height;

        const scale = window.devicePixelRatio || 1;

        const tempCanvas = document.createElement('canvas');
        const ctx = tempCanvas.getContext('2d');

       
        tempCanvas.width = Math.round(cssWidth * scale);
        tempCanvas.height = Math.round((cssHeight + 100) * scale); 
        tempCanvas.style.width = cssWidth + 'px';
        tempCanvas.style.height = (cssHeight + 100) + 'px';

        ctx.setTransform(scale, 0, 0, scale, 0, 0);

        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, cssWidth, cssHeight + 100);

        const spanElement = $divElement.find('span')[0];
        if (spanElement) {
            const spanStyles = window.getComputedStyle(spanElement);
            const fontSize = parseFloat(spanStyles.fontSize) || 16;
            ctx.font = `${fontSize}px ${spanStyles.fontFamily}`;
            ctx.fillStyle = spanStyles.color || '#000';

            const textX = 10;
            const textY = fontSize + 6; 
            ctx.fillText(spanElement.innerText, textX, textY);
        }

        const verticalMargin = 20;
        const baseFontSize = parseFloat(window.getComputedStyle(el).fontSize) || 16;
        const startYForChart = baseFontSize + verticalMargin;

        const chartCanvas = $divElement.find('canvas')[0];
        if (chartCanvas) {
            const chartCssW = chartCanvas.clientWidth || (chartCanvas.width / scale);
            const chartCssH = chartCanvas.clientHeight || (chartCanvas.height / scale);

            ctx.drawImage(chartCanvas, 0, startYForChart, chartCssW, chartCssH);
        }

        // zapisz do schowka
        if (tempCanvas.toBlob) {
            tempCanvas.toBlob((blob) => {
                const item = new ClipboardItem({ 'image/png': blob });
                navigator.clipboard.write([item])
                    .then(() => { toastr.info('', __l.CopiedImageToClipboard); })
                    .catch(() => { toastr.error('', __l.ErrorCannotCopy); });
            }, "image/png");
        } else {
            toastr.error('', __l.SomethingWentWrong);
        }
    }
}


//#endregion Helpers